import React, {useMemo, useState} from "react";
import "./../../utils/Style/pages/Banktransfers.scss";
import {useTable} from "react-table";
import {faArrowDown} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import Table from "../../components/Table";
import {useNavigate} from "react-router-dom";
import {useSelector} from "react-redux";
import VisibilityToggle from "../../components/Branch/VisibilityToggle";
import TableSkeleton from "../../components/skeletons/TableSkeleton";

const BranchesTemplate = (props) => {
    const {loading} = useSelector((state) => state.branches);

    const [activeRowIndex, setActiveRowIndex] = useState(-1);
    const navigate = useNavigate();

    const handleRowClick = (row) => {
        const BranchID = row.original.BranchID;
        navigate(`/branches/${BranchID}`, {
            state: {
                isEdit: false,
                data: {BranchID: BranchID},
            },
        });
    };
    const {branches} = useSelector((state) => state.branches);
    const columns = useMemo(
        () => [
            {
                Header: "Name",
                accessor: "Name",
                Cell: ({row, cell: {value}}) => {
                    return <button className="showmore branch-name" onClick={() => {
                        setActiveRowIndex(row.index);
                        handleRowClick(row)
                    }}>{value}</button>
                },
            },
            {
                Header: "Region",
                accessor: "Region",
            },
            {
                Header: "",
                accessor: "details",
                Cell: ({row}) => {
                    return <button className="showmore" onClick={() => {
                        setActiveRowIndex(row.index)
                    }}><FontAwesomeIcon icon={faArrowDown}/></button>
                },
            },
            {
                Header: "Location",
                accessor: "Location",
            },

            {
                Header: "Supervisor",
                accessor: (row) =>
                    row.Supervisors.map((supervisor, index) => (
                        <span key={index}>
                            {supervisor.FullName}
                            <br/>
                        </span>
                    )),
            },
            {
                Header: "Phone Number",
                accessor: (row) =>
                    row.Supervisors.map((supervisor, index) => (
                        <span key={index}>
                {supervisor.MobileNo}
                            <br/>
            </span>
                    )),
            },
            {
                Header: "Show For Suyool",
                accessor: "Status",
                Cell: ({row}) => {
                    const BranchID = row.original.BranchID;
                    const isVisible = row.original.ShowOnSuyool;
                    return (<VisibilityToggle isVisible={isVisible} branchID={BranchID} disabled={sessionStorage.getItem("EntityRole")==="Supervisor"}/>)

                },
            },
            {
                Header: "",
                accessor: "AS",
                Cell: ({row}) => {
                    const BranchID = row.original.BranchID;
                    return <button className="details" onClick={() => {
                        navigate(`/branches/edit/${BranchID}`, {
                            state: {
                                isEdit: true,
                                data: {BranchID},
                            },
                        });
                    }}>Edit</button>;

                },
            }
        ],
        []
    );
    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow
    } = useTable({columns, data: branches || []});

    return (
        <div className="col-lg-10 col-sm-12 ">
            {
                loading === "pending" ? (
                    <TableSkeleton/>
                ) : (
                    <Table
                        navigation="navigation"
                        headerGroups={headerGroups}
                        page={rows}
                        prepareRow={prepareRow}
                        getTableProps={getTableProps}
                        getTableBodyProps={getTableBodyProps}
                        activeRowIndex={activeRowIndex}
                        setActiveRowIndex={setActiveRowIndex}
                    />
                )
            }


            {sessionStorage.getItem("EntityRole") !== "Supervisor" &&
                <button className="newbranch" onClick={() => {
                    props.setActiveButton({name: "+ New Branch"})
                }}>+ NEW BRANCH
                </button>
            }

        </div>
    );
}
export default BranchesTemplate;